<template>
  <v-container fluid class="grey lighten-5" style="min-height: 100vmin">
    <v-row>
      <v-col cols="10" md="8">
        <v-tabs>
          <v-tab
            v-for="i in controle"
            :to="i.route"
            :key="i"
            color="#E74242"
            class="elevation-0"
            @click="this.controleSelecionado = i.name"
            >{{ i.name }}
          </v-tab>
        </v-tabs>
        <h1>Controle de Pedidos</h1>
      </v-col>
      <v-col class="text-right" cols="2" md="4">
        <v-btn
          v-if="!this.$isMobile()"
          elevation="0"
          color="red"
          @click="this.setDialog()"
          :disabled="empresaDesativada"
        >
          Novo Pedido
        </v-btn>
        <v-btn
          v-else
          size="x-small"
          elevation="0"
          color="red"
          @click="this.setDialog()"
          icon
          :disabled="empresaDesativada"
        >
          <v-icon>mdi-table-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <StatusCount></StatusCount>
    <v-row v-if="controleSelecionado != 'Todos'" class="grey">
      <RouterView></RouterView>
    </v-row>
    <v-row v-else class="grey">
      <Recebimentos v-if="this.controle.find((v) => v.name == 'Recebimentos')"></Recebimentos>
      <v-divider v-if="controleSelecionado == 'Todos' && this.controle.find((v) => v.name == 'Recebimentos')"></v-divider>
      <EmProducao v-if="this.controle.find((v) => v.name == 'Em Producao')" />
      <v-divider v-if="controleSelecionado == 'Todos' && this.controle.find((v) => v.name == 'Em Producao')"></v-divider>
      <Prontos v-if="this.controle.find((v) => v.name == 'Pronto')" />
      <v-divider v-if="controleSelecionado == 'Todos' && this.controle.find((v) => v.name == 'Pronto')"></v-divider>
      <Tele v-if="this.controle.find((v) => v.name == 'Tele | Aguardando Retirada')" />
      <v-divider v-if="controleSelecionado == 'Todos' && this.controle.find((v) => v.name == 'Tele | Aguardando Retirada')"></v-divider>
    </v-row>
  </v-container>
  <v-dialog v-model="this.dialog" style="z-index: 1000000">
    <Pedido />
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import setDialog from "../../libs/setDialog";

import EmProducao from "./containers/EmProducao.vue";

import Prontos from "./containers/Prontos.vue";

import Tele from "./containers/Tele.vue";

import Recebimentos from "./containers/Recebimentos.vue";

import Pedido from "./containers/Pedido.vue";

import StatusCount from "../../components/Status.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Pedidos",
  components: {
    EmProducao,
    Prontos,
    Tele,
    Recebimentos,
    Pedido,
    StatusCount,
  },
  data: () => ({
    pedidosPush: [],
    dadosempresa: [],
    controle: [
      { name: "Todos", route: "/pedidos" },
    ],
    controleSelecionado: "Todos",
    snackbar: false,
    horarios: [],
    text: "",
  }),
  watch: {
    '$route': {
      handler(newRoute) {
        if (newRoute.path === '/pedidos') {
          this.controleSelecionado = 'Todos';
        } else if (newRoute.path === '/pedidos/recebimentos') {
          this.controleSelecionado = 'Recebimentos';
        } else if (newRoute.path === '/pedidos/emproducao') {
          this.controleSelecionado = 'Em Producao';
        } else if (newRoute.path === '/pedidos/pronto') {
          this.controleSelecionado = 'Pronto';
        } else if (newRoute.path === '/pedidos/tele') {
          this.controleSelecionado = 'Tele | Aguardando Retirada';
        }  else {
          this.controleSelecionado = '';
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters([
      "clientes",
      "database",
      "pedidos",
      "dadosEmpresa",
      "dialog",
    ]),
    empresaDesativada() {
      return this.dadosEmpresa?.horarios?.[0]?.empresaAtiva === false;
    }
  },
  methods: {
    setDialog() {
      setDialog();
    },
  },
  mounted() {
    if (this.$route.path != "/pedidos") {
      this.controleSelecionado = "";
    }

    if(this.database.telas.pedidosEncomendas){
      for(let controle of this.database.telas.pedidosEncomendas){
        if(controle.group){
          if(controle.group == 'Pedidos' && controle.value == 'Recebimentos') {
            this.controle.push({ name: "Recebimentos", route: "/pedidos/recebimentos" })
          } else if(controle.group == 'Pedidos' && controle.value == 'Em Producao') {
            this.controle.push({ name: "Em Producao", route: "/pedidos/emproducao" })
          } else if(controle.group == 'Pedidos' && controle.value == 'Pronto') {
            this.controle.push({ name: "Pronto", route: "/pedidos/pronto" })
          } else if(controle.group == 'Pedidos' && controle.value == 'Tele | Aguardando Retirada') {
            this.controle.push({ name: "Tele | Aguardando Retirada", route: "/pedidos/tele" })
          }
        }
      }
    }
    if (localStorage.getItem("novoUser") == "true") {
      this.$router.push({
        name: "DadosCad",
      });
    }
  },
};
</script>
<style scoped>
::-webkit-scrollbar {
  display: solid;
}
.grey {
  animation: transitionIn 0.75s;
}
@keyframes transitionIn {
  from {
    opacity: 0;
    transform: rotateX(-10deg);
  }
  to {
    opacity: 1;
    transform: rotateX(0);
  }
}
.icons {
  font-size: 175%;
}
</style>
